import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import 'react-dates/initialize'
import ModalFullScreen from '../../mini/ModalFullScreen'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import CloseModal from '../../styled/CloseModal'
import { hideModal } from '../../../actions/_modal'
import {
  ErrorButton,
  ErrorHeaderBlock,
  Message,
  ButtonBlock,
  ModalQuestBlock,
  Container,
  Header,
  ModalTop
} from './_Styled'

const ErrorClosingJourneySection = () => {
  const [isClosing, setIsClosing] = useState(false)
  const dispatch = useDispatch()

  const closeTheModal = () => {

    setIsClosing(true)

    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  return (
    <ModalFullScreen
      padding={'200px 0 0'}
      allowEscape
      closeCallback={() => closeTheModal()}
      isClosing={isClosing}
      backgroundColor='rgba(36, 54, 70, 0.4)'
      allowCloseOnExternalClick
      bodyStyles={{ width: 'fit-content' }}
      className='close-section-error-message'
    >
      <CloseModal
        size={21}
        onClick={() => closeTheModal()}
        offWhiteIcon
      />
      <Container
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <React.Fragment>
          <ModalTop style={{ border: 'none' }}>
            <FlexAlignCenter
              style={{
                position: 'relative',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <ErrorHeaderBlock
                style={{ margin: '0 auto' }}
              >
                <Header>Error</Header>
              </ErrorHeaderBlock>
            </FlexAlignCenter>
          </ModalTop>
          <ModalQuestBlock style={{ border: 'none', margin: '0 auto' }}>
            <Message
              style={{ margin: '0 auto' }}
            >
              Oops! Something went wrong. Please try again.
              Contact support if this error persists.
            </Message>
          </ModalQuestBlock>
          <ButtonBlock>
            <ErrorButton onClick={() => closeTheModal()}>
              Okay
            </ErrorButton>
          </ButtonBlock>
        </React.Fragment>
      </Container>
    </ModalFullScreen>
  )
}

export default ErrorClosingJourneySection
